import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TitleComponent } from '@shared/components/title';
import { AbstractDynamicComponent } from '@components/abstracts';
import { MadeInFrance } from '@components/made-in-france/models';
import { SvgComponent } from '@shared/components/svg';

@Component({
  selector: 'app-made-in-france',
  imports: [TitleComponent, SvgComponent],
  templateUrl: './made-in-france.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MadeInFranceComponent extends AbstractDynamicComponent<MadeInFrance> {}
